module.exports = __webpack_public_path__ + "static/media/ManageAccounts@2x.20edcce0.jpg";